module.exports = __webpack_public_path__ + "img/182-Vert Sapin.jpg";